import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OptionSelector } from 'components';

class LogoOption extends Component {
  static propTypes = {
    logos: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired
    }).isRequired),
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
  }

  onChange = (name, value) => {
    this.props.onChange('logo', value);
  }

  render() {
    const { value, logos } = this.props;

    const logoValues = logos || [
      { value: 'default', label: 'default', icon: 'https://cdn.auth0.com/website/playground/others/auth0-default.svg' },
      { value: 'logo-tmz.svg', label: 'logo-tmz.svg', icon: 'https://cdn.auth0.com/website/playground/others/logo-tmz.svg' },
      { value: 'safari.svg', label: 'safari.svg', icon: 'https://cdn.auth0.com/website/playground/others/safari.svg' },
      { value: 'schneider.svg', label: 'schneider.svg', icon: 'https://cdn.auth0.com/website/playground/others/schneider.svg' }
    ];

    return (
      <OptionSelector
        name="logo"
        onChange={this.onChange}
        options={logoValues}
        value={value}
      />
    );
  }
}

export default LogoOption;



// WEBPACK FOOTER //
// ./src/components/EditorOption/LogoOption.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/LogoOption.js